import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import { CardTitle } from 'react-toolbox/lib/card'

import styles from './styles.scss'

const LoginCard = (props) => (
  <CardTitle
    theme={styles}
    title='Sign in'
    subtitle='to continue to Fulcrum'
  />
)

const withStyle = CSSModules(styles)
export default withStyle(LoginCard)
